module.exports = __webpack_public_path__ + "static/pfs-desktop-0a088324d0c91cc9b7f7a2499dae6daa.png";